import React from "react";
import styled from "styled-components";

const Image = styled.img`
    width: 100%;
`;


const Wrapper = styled.button`
    background-color: transparent;
    border: none;
    border-radius: 3px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
    cursor: pointer;
    height: auto;
    outline: none;
    transition: all 300ms ease;
    width: 100%;

    &:hover {
        box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
        opacity: 0.7;
    }
`;


const AssessmentCoversCard = ({ data, handleClick, label }) => {
    return (
        <Wrapper>
            <div className="1212 card-resource card-resourceCstm">
                <a onClick={handleClick}>
                    <div className="card-resource-overlay"></div>
                    <Image className="card-resource-image" src={data.src} alt={data.displayName} />
                    {/* {showLabel && <Label bgColor={labelBgColor}>{label}</Label>} */}
                    <div className="card-resource-details fadeIn-bottom">
                        <h3 className="card-resource-title">{data.displayName}</h3>
                        {/* <p className="card-resource-text">{data.label}</p> */}
                    </div>
                    {/* <TextContainer>
                        <Text>{data.displayName}</Text>
                    </TextContainer> */}
                </a>
            </div>
        </Wrapper>
    );
};



export default AssessmentCoversCard;